// extracted by mini-css-extract-plugin
export default {"title":"LD4g4","left":"NJisq","icon":"aDAT0","text":"X86Xp","chevron":"vKsN0","banner":"saW2J"};